import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DarkModeService } from '../../shared/services/darkmode.service';
import { HeroSectionComponent } from '../../shared/components/hero-section/hero-section.component';
import { Title } from '@angular/platform-browser';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
@Component({
  selector: 'app-about',
  imports: [TranslateModule, HeroSectionComponent, CarouselModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
})
export class AboutComponent implements OnInit {
  public darkMode: boolean = false;
  public areas: any[] = [];
  public titles: string[] = [];
  customOptions: OwlOptions = {
    // When carousel not needed, set false to mouseDrag, pullDrag, dots and nav
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    margin: 0,
    stagePadding: 0,
    navSpeed: 700,
    items: 1,
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
    },
  };
  constructor(
    private darkmodeService: DarkModeService,
    private titleService: Title,
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('AYR | About');
    this.darkmodeService.isDarkMode.subscribe((isDark) => {
      this.darkMode = isDark;
    });
    this.buildAreas();
  }

  getStyle(styleString: string, originalColor: string, newColor: string) {
    // return this.sidebarService.getStyle(
    //   styleString,
    //   originalColor,
    //   newColor,
    //   this.darkMode
    // );
  }
  buildAreas() {
    this.titles = [
      'about.icons.automotive',
      'about.icons.mobility',
      'about.icons.aeronautics',
      'about.icons.ocean',
      'about.icons.space',
    ];
    let automotive = {
      image: 'Automotive.svg',
      alt: 'Car icon',
      href: 'automotive',
    };

    let mobility = {
      image: 'Mobility.svg',
      alt: 'Point A to point B icon',
      href: 'mobility',
    };

    let aeronautics = {
      image: 'Aeronautics.svg',
      alt: 'Plane icon',
      href: 'aeronautics',
    };

    let ocean = {
      image: 'Ocean.svg',
      alt: 'Ocean equipment icon',
      href: 'oceanspace',
    };

    let space = {
      image: 'Space.svg',
      alt: 'Space probe icon',
      href: 'oceanspace',
    };
    this.areas.push(automotive);
    this.areas.push(mobility);
    this.areas.push(aeronautics);
    this.areas.push(ocean);
    this.areas.push(space);
  }
}
